import JwtService from "@/services/jwt.service";
import store from '@/stores/index';
import Vue from 'vue';

export const Authenticate = {
    excepted: ['dashboard'],
    async authenticated(_routeTo) {
        if (store.state.auth.isAuthenticated) {
            if (await this.havePermission(_routeTo, store.state.auth.user)) {
                return true;
            } else {
                Vue.$notify.danger("Desculpe, porém você não tem permissão para acessar esse recurso!");
                return false;
            }
        } else if (JwtService.getToken() != null) {
            const auth = await store.dispatch('auth/getUser');

            if (auth != null) {
                if (await this.havePermission(_routeTo, auth.user)) {
                    return true;
                } else {
                    Vue.$notify.danger("Desculpe, porém você não tem permissão para acessar esse recurso!");
                    return false;
                }
            }
        }

        store.dispatch('auth/logout');
        return false;
    },

    async havePermission(_routeTo, _user) {
        var i;
        if (this.excepted.indexOf(_routeTo.name) !== -1) 
            return true;
            
        var permissions = store.state.auth.permissions;
        if (!permissions.length)
            permissions = await store.dispatch('auth/getPermissions', _user.id);

        for(i=0;(i < permissions.length && permissions[i].route !== _routeTo.name.replace('print-', '')); i++);
        
        return (permissions.length !== i);
    }
};
